import { render } from "./SystemLogsAiCalls.vue?vue&type=template&id=252238b3&scoped=true"
import script from "./SystemLogsAiCalls.vue?vue&type=script&lang=js"
export * from "./SystemLogsAiCalls.vue?vue&type=script&lang=js"

import "./SystemLogsAiCalls.vue?vue&type=style&index=0&id=252238b3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-252238b3"]])

export default __exports__